import React, { useState } from "react";
import { Container, Logo } from "./styles";
import { MenuOutlined } from "@ant-design/icons";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import { useCart } from "../../hooks/CartContext";
import userPhoto from "../../images/user.png";
import logo from "../../images/logo.png";
import { Button, Drawer, Tooltip } from "antd";
import Menu from "../Menu";
import { MdClose, MdShoppingCart, MdWarning } from "react-icons/md";
import { getValue } from "../../services/functions";

const Header = ({ sidebar, onToggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { cart, getCartTotals } = useCart();
  const [visible, setVisible] = useState(false);

  const cartTotals = getCartTotals();

  const isSolicitacaoPage = location.pathname === "/solicitacao";

  return (
    <Container>
      {sidebar && (
        <>
          <Button
            className="menu"
            type="primary"
            style={{ paddingBottom: 0 }}
            icon={<MenuOutlined />}
            onClick={() => setVisible(true)}
          />
          <Drawer
            title="Menu"
            placement="left"
            closeIcon={<MdClose color="#FFF" size={25} />}
            width={250}
            onClick={() => setVisible(false)}
            onClose={() => setVisible(false)}
            styles={{
              body: {
                background: "#008037",
                padding: 0,
              },
              header: {
                padding: "12px 10px",
                background: "#008037",
                color: "#FFF",
                fill: "#FFF",
              },
            }}
            open={visible}
          >
            <Menu />
          </Drawer>
        </>
      )}

      <Logo sidebar={sidebar}>
        <img src={logo} alt="" />
      </Logo>

      {user && (
        <div style={{ display: "flex", alignItems: "center" }}>
          {user.type === "cliente" &&
            !isSolicitacaoPage &&
            (cartTotals.itemsCount > 0 || cart.servicesOrder.length > 0) && (
              <Tooltip title="Solicitação em andamento">
                <Button
                  type="text"
                  className="cart-button"
                  onClick={() => navigate("/solicitacao")}
                >
                  <MdShoppingCart
                    style={{ fontSize: 20, marginRight: 8, color: "inherit" }}
                  />
                  <span>
                    {cartTotals.itemsCount} itens -{" "}
                    {getValue(cartTotals.totalValue)}
                  </span>
                </Button>
              </Tooltip>
            )}
          {user.type === "cliente" && (
            <Tooltip title="Histórico de Comunicados">
              <Button
                type="text"
                shape="circle"
                icon={<MdWarning style={{ fontSize: 20, color: "#fff" }} />}
                onClick={() => navigate("/cliente/comunicados")}
                style={{
                  marginRight: 15,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#008037",
                }}
              />
            </Tooltip>
          )}
          {sidebar ? (
            <p className="info">
              Seja bem-vindo, {user.name?.split(" ")[0] || ""}
            </p>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                navigate(-1);
              }}
              style={{
                borderRadius: 50,
                height: 30,
                fontSize: 13,
                alignSelf: "center",
                marginRight: 25,
              }}
            >
              Voltar para a Página Anterior
            </Button>
          )}
          <button
            style={{ marginLeft: 10 }}
            onClick={() => {
              navigate(`/${user.type}/perfil`);
            }}
          >
            <img src={user.photo ? user.photo_url : userPhoto} />
          </button>
        </div>
      )}
    </Container>
  );
};

export default Header;
